// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Default from '@/layouts/Default.vue'
import LoginLayout from '@/layouts/LoginLayout.vue'
import { VuejsDatatableFactory } from 'vuejs-datatable'
import DateTimePicker from 'vue-vanilla-datetime-picker'
import VModal from 'vue-js-modal'
import VueFlashMessage from 'vue-flash-message';
import validUrl from 'valid-url'; 
import * as emailValidator from 'email-validator'


import VuejsDialog from 'vuejs-dialog';
Vue.prototype.$eventBus = new Vue();
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
Vue.component('default-layout', Default)
Vue.component('login-layout-Layout', LoginLayout)
Vue.component('date-time-picker', DateTimePicker)
Vue.use(VuejsDatatableFactory)
Object.defineProperty(Vue.prototype, 'validUrl', { value: validUrl });
Object.defineProperty(Vue.prototype, 'emailValidator', { value: emailValidator });

Vue.use(emailValidator)
Vue.config.productionTip = false
Vue.use(VuejsDialog);
Vue.use(VueFlashMessage, {
messageOptions: {
   timeout: 3000
  }
});
Vue.use(VModal, { dynamic: true, injectModalsContainer: true })
Vue.mixin({
  methods: {
    checkExtension: function (ext) {
      if (!ext) return false
      let fileExtensions = ['jpeg', 'jpg', 'png', 'gif']
      let extension = ext.toLowerCase()
      if (fileExtensions.indexOf(extension) > -1) {
        return true
      }
      return false
    }
  }
})

 
// Tell Vue to install the plugin.


/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js